<template>
  <div>
    <printing-page>
      <papers-header
        v-if="isAvailablePrintData"
        title="صحيفة الدعوى"
      ></papers-header>
      <paper>
        <lawsuit-ticket
          :request-object-key="requestObjectKey"
          :for-party-authentications="true"
          @getData="getData"
        ></lawsuit-ticket>
      </paper>

      <template v-if="isAvailablePrintData && printData">
        <papers-footer></papers-footer>
        <party-authentications
          :case-type-id="printData.caseInfo.caseTypeId"
          :request-object-key="requestObjectKey"
        ></party-authentications>
      </template>
    </printing-page>
  </div>
</template>

<script>
import PrintingPage from '@/components/printing/page.vue';
import Paper from '@/components/printing/paper.vue';
import PapersHeader from '@/components/printing/header.vue';
import PapersFooter from '@/components/printing/footer.vue';
import LawsuitTicket from '../components/lawsuit-ticket/index.vue';
import PartyAuthentications from '../components/party-authentications/index';

export default {
  components: {
    PrintingPage,
    Paper,
    PapersHeader,
    PapersFooter,
    LawsuitTicket,
    PartyAuthentications,
  },
  data() {
    return {
      isAvailablePrintData: false,
      printData: null,
    };
  },
  computed: {
    requestObjectKey() {
      return this.$route.params.objectKey;
    },
  },
  methods: {
    getData(printDataModel) {
      if (printDataModel) {
        this.printData = printDataModel;
        this.isAvailablePrintData = true;
      }
    },
  },
};
</script>
